import $ from 'jquery';
import ajaxSearchCars from './sopimus-ajax-search-car';

const searchDropDownList = {
  init: function() {
    $('body').on('click', '.dropdown', function(event) {
      $(this)
        .find('li')
        .click(() => {
          const value = $(this)
            .find('input')
            .attr('value');
          const id = $(this)
            .find('input')
            .attr('id');
          if (window.searchOptions[id] !== value) {
            if (value.indexOf('null') !== -1) {
              $(this)
                .find('input')
                .attr('value', false);
              window.searchOptions[id] = false;
              ajaxSearchCars(window.searchOptions);
            } else {
              window.searchOptions[id] = value;
              ajaxSearchCars(window.searchOptions);
            }
          }
        });
    });
  }
};
module.exports = searchDropDownList;
